import { render, staticRenderFns } from "./cmdModiParams.vue?vue&type=template&id=96e05d22&scoped=true&"
import script from "./cmdModiParams.vue?vue&type=script&lang=js&"
export * from "./cmdModiParams.vue?vue&type=script&lang=js&"
import style0 from "./cmdModiParams.vue?vue&type=style&index=0&id=96e05d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e05d22",
  null
  
)

export default component.exports